import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context";
import { t } from "../content";
import { http } from "../api";
import { ProductCard } from "../components/ProductCard";
import { ArrowRight } from "lucide-react";

const HERO = "/products/hero.jpg?v=2";
const AEST = "/products/aesthetic.jpg";

export default function Home() {
  const { lang } = useLang();
  const [news, setNews] = useState([]);

  useEffect(() => {
    http.get("/products?collection=nouveautes").then((r) => setNews(r.data.slice(0, 8)));
  }, []);

  return (
    <div>
      {/* Hero */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-12 lg:pt-20">
        <div className="grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-5 fade-up">
            <p className="text-xs uppercase tracking-[0.3em] text-[#737373] mb-6">{t.hero.eyebrow[lang]}</p>
            <h1 className="serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">{t.hero.title[lang]}</h1>
            <p className="mt-8 text-base text-[#404040] leading-relaxed max-w-md">{t.hero.sub[lang]}</p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link to="/shop" data-testid="hero-cta" className="group inline-flex items-center gap-2 bg-[#1A1A1A] text-[#F9F8F6] px-7 py-3.5 text-sm uppercase tracking-widest rounded-sm hover:gap-3 transition-all">
                {t.hero.cta[lang]} <ArrowRight size={16} strokeWidth={1.5} />
              </Link>
              <Link to="/shop?c=crews" data-testid="hero-cta-2" className="inline-flex items-center px-7 py-3.5 text-sm uppercase tracking-widest border border-[#1A1A1A] rounded-sm hover:bg-[#1A1A1A] hover:text-[#F9F8F6] transition-colors">
                {t.hero.cta2[lang]}
              </Link>
            </div>
          </div>
          <div className="lg:col-span-7 img-zoom aspect-[4/3] lg:aspect-[16/13] bg-[#F0EBE1] fade-up">
            <img src={HERO} alt="ClassOne Vintage" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>

      {/* Marquee */}
      <section className="mt-20 border-y border-[#1A1A1A]/10 py-4 overflow-hidden bg-[#F0EBE1]">
        <div className="marquee-track text-sm tracking-[0.3em] uppercase text-[#1A1A1A]/70">
          {(t.marquee[lang] + t.marquee[lang]).repeat(2)}
        </div>
      </section>

      {/* Nouveautés */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 mt-24">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="serif text-4xl">{t.sections.new[lang]}</h2>
            <p className="text-sm text-[#737373] mt-2">{t.sections.newSub[lang]}</p>
          </div>
          <Link to="/shop?c=nouveautes" className="co-link text-sm uppercase tracking-widest hidden sm:block">{t.sections.viewAll[lang]}</Link>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {news.map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
        </div>
      </section>

      {/* Notre esthétique */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 mt-28">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="img-zoom aspect-[4/5] bg-[#F0EBE1] order-2 lg:order-1">
            <img src={AEST} alt="aesthetic" className="w-full h-full object-cover" />
          </div>
          <div className="order-1 lg:order-2">
            <p className="text-xs uppercase tracking-[0.3em] text-[#737373] mb-5">{t.sections.aesthetic[lang]}</p>
            <h2 className="serif text-4xl lg:text-5xl leading-tight mb-8">{t.sections.aesthetic[lang]}</h2>
            <p className="text-base text-[#404040] leading-relaxed max-w-lg">{t.sections.aestheticBody[lang]}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
